"use client";

const font = "'IBM Plex Mono', monospace";

interface GameRow {
  title: string;
  rhae: number;
  totalLevels: number;
  finalState: "WIN" | "GAME_OVER" | "NOT_FINISHED";
  actions: number[];
  baselines: number[];
}

const MAX_LEVELS = 10;

const games: GameRow[] = [
  {
    title: "CN04",
    rhae: 97.6,
    totalLevels: 6,
    finalState: "WIN",
    actions: [20, 19, 22, 21, 35],
    baselines: [16, 54, 69, 318, 208, 114],
  },
  {
    title: "LP85",
    rhae: 84.16,
    totalLevels: 8,
    finalState: "WIN",
    actions: [17, 11, 18, 18, 23, 153, 19, 13],
    baselines: [33, 22, 31, 23, 33, 34, 73, 173],
  },
  {
    title: "AR25",
    rhae: 83.28,
    totalLevels: 8,
    finalState: "WIN",
    actions: [50, 30, 97, 28, 73, 84, 106, 47],
    baselines: [17, 22, 103, 29, 29, 159, 152, 66],
  },
  {
    title: "FT09",
    rhae: 77.59,
    totalLevels: 6,
    finalState: "WIN",
    actions: [3, 7, 14, 21, 21, 56],
    baselines: [17, 19, 15, 21, 65, 26],
  },
  {
    title: "CD82",
    rhae: 70.15,
    totalLevels: 6,
    finalState: "WIN",
    actions: [60, 36, 57, 14, 16, 20],
    baselines: [41, 8, 30, 21, 19, 17],
  },
  {
    title: "TR87",
    rhae: 69.21,
    totalLevels: 6,
    finalState: "GAME_OVER",
    actions: [42, 32, 39, 29, 43, 3962],
    baselines: [37, 30, 39, 29, 63, 119],
  },
  {
    title: "TU93",
    rhae: 67.87,
    totalLevels: 9,
    finalState: "WIN",
    actions: [17, 18, 23, 45, 81, 62, 14, 91, 48],
    baselines: [19, 15, 34, 42, 76, 91, 47, 23, 31],
  },
  {
    title: "KA59",
    rhae: 65.33,
    totalLevels: 7,
    finalState: "NOT_FINISHED",
    actions: [37, 56, 37, 52, 27, 113, 59],
    baselines: [39, 175, 86, 47, 21, 132, 326],
  },
  {
    title: "SB26",
    rhae: 49.35,
    totalLevels: 8,
    finalState: "WIN",
    actions: [18, 221, 15, 20, 17, 19, 67, 203],
    baselines: [18, 16, 15, 15, 31, 24, 17, 17],
  },
  {
    title: "M0R0",
    rhae: 40.06,
    totalLevels: 6,
    finalState: "NOT_FINISHED",
    actions: [25, 43, 121, 12, 61],
    baselines: [30, 209, 83, 86, 436, 126],
  },
  {
    title: "RE86",
    rhae: 35.54,
    totalLevels: 8,
    finalState: "NOT_FINISHED",
    actions: [24, 37, 61, 132, 66, 280, 263],
    baselines: [28, 38, 198, 57, 84, 117, 328, 221],
  },
  {
    title: "SU15",
    rhae: 35.17,
    totalLevels: 9,
    finalState: "NOT_FINISHED",
    actions: [16, 232, 17, 105, 136, 90, 27, 150],
    baselines: [18, 28, 50, 151, 18, 31, 50, 179, 41],
  },
  {
    title: "S5I5",
    rhae: 23.85,
    totalLevels: 8,
    finalState: "NOT_FINISHED",
    actions: [33, 72, 77, 141, 365],
    baselines: [19, 57, 85, 203, 82, 30, 76, 56],
  },
  {
    title: "WA30",
    rhae: 22.22,
    totalLevels: 9,
    finalState: "NOT_FINISHED",
    actions: [39, 58, 86, 80, 132],
    baselines: [125, 58, 259, 113, 499, 58, 186, 134, 132],
  },
  {
    title: "SC25",
    rhae: 18.42,
    totalLevels: 6,
    finalState: "GAME_OVER",
    actions: [78, 9, 30, 42],
    baselines: [39, 5, 32, 33, 66, 41],
  },
  {
    title: "VC33",
    rhae: 17.14,
    totalLevels: 7,
    finalState: "NOT_FINISHED",
    actions: [11, 15, 29, 143],
    baselines: [6, 13, 31, 59, 92, 24, 82],
  },
  {
    title: "DC22",
    rhae: 15.56,
    totalLevels: 6,
    finalState: "GAME_OVER",
    actions: [94, 99, 114, 128],
    baselines: [64, 117, 59, 78, 324, 550],
  },
  {
    title: "G50T",
    rhae: 8.7,
    totalLevels: 7,
    finalState: "NOT_FINISHED",
    actions: [69, 180, 467],
    baselines: [51, 175, 86, 52, 96, 48, 67],
  },
  {
    title: "LS20",
    rhae: 7.13,
    totalLevels: 7,
    finalState: "NOT_FINISHED",
    actions: [26, 387, 251, 213, 212, 502],
    baselines: [21, 123, 39, 92, 54, 108, 109],
  },
  {
    title: "LF52",
    rhae: 5.36,
    totalLevels: 10,
    finalState: "NOT_FINISHED",
    actions: [23, 137, 246, 174, 928],
    baselines: [24, 81, 74, 86, 118, 148, 189, 116, 150, 225],
  },
  {
    title: "R11L",
    rhae: 4.76,
    totalLevels: 6,
    finalState: "NOT_FINISHED",
    actions: [4, 432],
    baselines: [7, 28, 30, 20, 37, 45],
  },
  {
    title: "TN36",
    rhae: 1.31,
    totalLevels: 7,
    finalState: "NOT_FINISHED",
    actions: [57, 69, 528],
    baselines: [23, 22, 26, 37, 25, 56, 61],
  },
  {
    title: "SK48",
    rhae: 1.21,
    totalLevels: 8,
    finalState: "NOT_FINISHED",
    actions: [74, 72, 266],
    baselines: [15, 32, 35, 113, 304, 42, 63, 92],
  },
  {
    title: "SP80",
    rhae: 0.73,
    totalLevels: 6,
    finalState: "GAME_OVER",
    actions: [28, 120],
    baselines: [11, 18, 17, 172, 102, 152],
  },
  {
    title: "BP35",
    rhae: 0.22,
    totalLevels: 9,
    finalState: "GAME_OVER",
    actions: [48, 10],
    baselines: [15, 72, 36, 31, 31, 48, 86, 155, 163],
  },
];

export function ScoreBreakdown() {
  return (
    <div style={{ width: "100%", overflowX: "auto", margin: "24px 0" }}>
      <div
        style={{
          display: "flex",
          gap: "20px",
          marginBottom: "10px",
          fontFamily: font,
          fontSize: "10px",
          color: "#888",
        }}
      >
        <span
          style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
        >
          <span
            style={{
              display: "inline-block",
              width: "12px",
              height: "12px",
              borderRadius: "2px",
              background: "rgba(110,231,160,0.12)",
            }}
          />
          Beat human baseline
        </span>
        <span
          style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
        >
          <span
            style={{
              display: "inline-block",
              width: "12px",
              height: "12px",
              borderRadius: "2px",
              border: "1.5px solid #6ee7a0",
            }}
          />
          Game won
        </span>
        <span
          style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
        >
          <span
            style={{
              display: "inline-block",
              width: "12px",
              height: "12px",
              borderRadius: "2px",
              border: "1.5px solid #f87171",
            }}
          />
          Game ended
        </span>
      </div>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontFamily: font,
          fontSize: "11px",
          background: "#1a1a1a",
          borderRadius: "8px",
          overflow: "hidden",
          border: "1px solid #2a2a2a",
          minWidth: "720px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                padding: "8px 10px",
                textAlign: "left",
                color: "#888",
                fontWeight: 500,
                fontSize: "10px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderBottom: "2px solid #2a2a2a",
                background: "#141414",
                position: "sticky",
                left: 0,
                zIndex: 1,
              }}
            >
              Game
            </th>
            {Array.from({ length: MAX_LEVELS }, (_, i) => (
              <th
                key={i}
                style={{
                  padding: "8px 6px",
                  textAlign: "center",
                  color: "#888",
                  fontWeight: 500,
                  fontSize: "10px",
                  letterSpacing: "0.08em",
                  borderBottom: "2px solid #2a2a2a",
                  background: "#141414",
                  minWidth: "48px",
                }}
              >
                L{i + 1}
              </th>
            ))}
            <th
              style={{
                padding: "8px 10px",
                textAlign: "right",
                color: "#9b9dff",
                fontWeight: 600,
                fontSize: "10px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderBottom: "2px solid #2a2a2a",
                borderLeft: "1px solid #2a2a2a",
                background: "#141414",
              }}
            >
              Score
            </th>
          </tr>
        </thead>
        <tbody>
          {games.map((game, rowIdx) => (
            <tr
              key={game.title}
              style={{
                background:
                  rowIdx % 2 === 0 ? "transparent" : "rgba(255,255,255,0.015)",
                borderBottom:
                  rowIdx < games.length - 1 ? "1px solid #222" : "none",
              }}
            >
              <td
                style={{
                  padding: "6px 10px",
                  color:
                    game.finalState === "WIN"
                      ? "#6ee7a0"
                      : "rgba(255,255,255,0.55)",
                  fontWeight: game.finalState === "WIN" ? 600 : 400,
                  whiteSpace: "nowrap",
                  position: "sticky",
                  left: 0,
                  background: rowIdx % 2 === 0 ? "#1a1a1a" : "#1c1c1c",
                  zIndex: 1,
                }}
              >
                {game.title}
              </td>
              {Array.from({ length: MAX_LEVELS }, (_, i) => {
                const hasLevel = i < game.totalLevels;
                const hasAction = i < game.actions.length;

                if (!hasLevel) {
                  return (
                    <td
                      key={i}
                      style={{
                        padding: "6px 6px",
                        textAlign: "center",
                        background: "#000",
                      }}
                    />
                  );
                }

                if (!hasAction) {
                  return (
                    <td
                      key={i}
                      style={{
                        padding: "6px 6px",
                        textAlign: "center",
                        color: "rgba(255,255,255,0.15)",
                      }}
                    >
                      —
                    </td>
                  );
                }

                const actions = game.actions[i]!;
                const baseline = game.baselines[i]!;
                const isLastAction = i === game.actions.length - 1;
                const beatHuman =
                  actions <= baseline &&
                  !(isLastAction && game.finalState !== "WIN");
                const borderColor = isLastAction
                  ? game.finalState === "WIN"
                    ? "#6ee7a0"
                    : "#f87171"
                  : undefined;

                return (
                  <td
                    key={i}
                    style={{
                      padding: "6px 6px",
                      textAlign: "center",
                      color: "rgba(255,255,255,0.75)",
                      fontSize: "10px",
                      fontWeight: 400,
                      background: beatHuman
                        ? "rgba(110,231,160,0.12)"
                        : undefined,
                      border: borderColor
                        ? `1.5px solid ${borderColor}`
                        : undefined,
                    }}
                  >
                    {actions.toLocaleString()}
                  </td>
                );
              })}
              <td
                style={{
                  padding: "6px 10px",
                  textAlign: "right",
                  color: "#fff",
                  fontWeight: 500,
                  borderLeft: "1px solid #2a2a2a",
                  fontSize: "11px",
                }}
              >
                {game.rhae.toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ borderTop: "2px solid #2a2a2a" }}>
            <td
              colSpan={MAX_LEVELS + 1}
              style={{
                padding: "8px 10px",
                textAlign: "right",
                color: "#888",
                fontWeight: 500,
                fontSize: "10px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                background: "#141414",
              }}
            >
              Overall
            </td>
            <td
              style={{
                padding: "8px 10px",
                textAlign: "right",
                color: "#9b9dff",
                fontWeight: 600,
                fontSize: "12px",
                borderLeft: "1px solid #2a2a2a",
                background: "#141414",
              }}
            >
              {(games.reduce((s, g) => s + g.rhae, 0) / games.length).toFixed(
                2
              )}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
